import styled from 'styled-components';
import ContactHeader from '../../global/typography/ContactHeader';

export default styled(ContactHeader)`
  font-size: 16px;
`;
